import { computed, inject, Injectable, Signal } from '@angular/core';

import { HasPermissionsService, OperatorEnum } from '@connect-services/client/services/has-permissions.service';
import { PermissionAliasEnum } from '@connect-services/src/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class WarehouseAndFormsAccessPermissionsService {
    public readonly initialized: Signal<boolean> = computed(() => this.hasPermissionsService.initialized());
    private readonly hasPermissionsService = inject(HasPermissionsService);

    public canAccessData(): boolean {
        return this.canAccessWarehouse() || this.canAccessForms();
    }

    public canAccessForms(): boolean {
        return this.hasPermissionsService.checkPermissions(
            [PermissionAliasEnum.MANAGE_FIELD_INTERVENTION_FORM, PermissionAliasEnum.READ_FIELD_INTERVENTION_FORM],
            OperatorEnum.OR,
        );
    }

    public canAccessWarehouse(): boolean {
        return this.hasPermissionsService.checkPermissions(
            [PermissionAliasEnum.MANAGE_DEPOSIT, PermissionAliasEnum.READ_DEPOSIT],
            OperatorEnum.OR,
        );
    }

    public canManageDeposit(): boolean {
        return this.hasPermissionsService.checkPermissions([PermissionAliasEnum.MANAGE_DEPOSIT]);
    }
}
